import Vue from 'vue'
import Vuex from 'vuex'
import host from './host'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    host: host
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
